// src/constants/types.js

export const TYPE_COLORS = {
  normal: {
    bg: "#e9e9e9",
    text: "#111",
  },
  fire: {
    bg: "#e44848",
    text: "#fff",
  },
  water: {
    bg: "#3a7ff0",
    text: "#fff",
  },
  grass: {
    bg: "#25c05a",
    text: "#fff",
  },
  electric: {
    bg: "#f5d300",
    text: "#111",
  },
  ice: {
    bg: "#7fd7ff",
    text: "#111",
  },
  fighting: {
    bg: "#b33a3a",
    text: "#fff",
  },
  poison: {
    bg: "#9b59b6",
    text: "#fff",
  },
  ground: {
    bg: "#c8a24a",
    text: "#111",
  },
  flying: {
    bg: "#8fa8ff",
    text: "#111",
  },
  psychic: {
    bg: "#ff5fa2",
    text: "#fff",
  },
  bug: {
    bg: "#a8c820",
    text: "#111",
  },
  rock: {
    bg: "#b8a038",
    text: "#111",
  },
  ghost: {
    bg: "#705898",
    text: "#fff",
  },
  dragon: {
    bg: "#7038f8",
    text: "#fff",
  },
  dark: {
    bg: "#4a4a4a",
    text: "#fff",
  },
  steel: {
    bg: "#b8b8d0",
    text: "#111",
  },
  fairy: {
    bg: "#f4a1c0",
    text: "#111",
  },
};

// fallback if type missing
export const DEFAULT_TYPE_STYLE = {
  bg: "#f3f3f3",
  text: "#111",
};
